<template>
  <v-container fluid>
    <base-material-card color="primary" icon="mdi-file-search-outline" inline class="ml-0 px-5 py-4">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">Qtd Material x Serviços</div>
      </template>
      <v-btn
        id="btn-novo-teste"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left"
        relative
        text
        medium
        @click="$router.push('edit')"
      >
        <v-icon left size="30px">mdi-plus-circle</v-icon>
        Novo Teste
      </v-btn>
      <v-text-field
        id="teste-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />
      <general-progress-bars class="mt-11" :items="downloadProgressData" prefix-text="Baixando Teste" />
      <v-divider class="mt-10" />
      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        :header-props="{
          sortByText: 'Ordenar Por'
        }"
        :footer-props="{
          itemsPerPageText: 'Itens por Página'
        }"
        :loading="loading"
        no-data-text="Nenhum Teste disponível"
        no-results-text="Nenhum registro correspondente encontrado"
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:[`item.titulo`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="text-truncate-column" v-bind="attrs" v-on="on">
                {{ item.titulo }}
              </div>
            </template>
            <span>{{ item.titulo }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="action-download-teste"
            :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :loading="downloadProgressData[item.id] !== undefined ? true : false"
            :disabled="item.status != 'SUCESSO'"
            @click="downloadItem(item)"
          >
            <v-icon small>mdi-download</v-icon>
          </v-btn>
          <v-btn
            id="action-edit-teste"
            :class="!canEditItem(item) ? 'cursor-block' : ''"
            :disabled="!canEditItem(item)"
            min-width="0"
            class="ml-n1 px-1"
            fab
            icon
            x-small
            @click="$router.push(`edit/${item.id}`)"
          >
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-more-teste"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>mdi mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="canRunItem(item)" @click="executarItem(item.id)">
                <v-list-item-title>
                  <v-icon small>mdi-play</v-icon>
                  Executar
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="duplicarItem(item.id)">
                <v-list-item-title>
                  <v-icon small>mdi-content-copy</v-icon>
                  Duplicar
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="openDialogDelete(item.id, item.titulo)">
                <v-list-item-title>
                  <v-icon small>mdi-trash-can-outline</v-icon>
                  Deletar
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="openDialogDetalhes(item)">
                <v-list-item-title>
                  <v-icon small>mdi-file-find-outline</v-icon>
                  Detalhes
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="
                  ((dialogCreationLog = true),
                  (dialogCreationLogData = {
                    username: item.usuario,
                    created: item.created
                  }))
                "
              >
                <v-list-item-title>
                  <v-icon small>mdi-table-search</v-icon>
                  Log
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`footer`]>
          <v-switch
            v-if="$store.getters.userIsAdmin"
            class="pa-0 pl-2 swithInterna"
            style="position: absolute"
            color="primary"
            label="Exibir Expirados"
            dense
            @change="$emit('switchProcessamentosExpirados', $event)"
          />
        </template>
        <template v-slot:[`footer.page-text`]>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" v-bind="attrs" v-on="on" @click="$emit('rechargeTable')">mdi-refresh</v-icon>
            </template>
            <span>Clique aqui para recarregar os teste</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
    <dialog-delete
      :show-dialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="deletarItem(dialogDeleteData.id)"
    >
      <template slot="title">Deletar teste #{{ dialogDeleteData.id }}</template>
      <template slot="body">
        Tem certeza que deseja deletar o teste
        <strong>{{ dialogDeleteData.titulo }}</strong>
        ?
      </template>
    </dialog-delete>
    <dialog-creation-log :dialog.sync="dialogCreationLog" :item="dialogCreationLogData" />
    <general-dialog-detalhes
      ref="dialogDetalhes"
      title="Detalhes do Teste"
      :show-dialog="dialogDetalhes"
      @changeValue="dialogDetalhes = $event"
    >
      <template slot="body">
        <v-data-table
          :headers="[
            { text: 'Parâmetro', value: 'parametro', sortable: false },
            { text: 'Valor', value: 'valor', sortable: false }
          ]"
          :items="dialogDetalhesData"
          hide-default-footer
          class="elevation-1 style-table-dialog-detalhes"
          disable-pagination
        >
          <template v-slot:item="row">
            <tr>
              <td class="button">
                {{ row.item.parametro }}
              </td>
              <td v-if="row.item.parametro.indexOf('Obras') !== -1" class="button pl-0">
                <v-textarea rows="5" no-resize readonly class="ml-4 mt-0 pt-0" :value="row.item.valor" />
              </td>
              <td v-else class="button">
                {{ row.item.valor }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </general-dialog-detalhes>
  </v-container>
</template>

<script>
  import TesteQtdMatServService from '@/services/TesteQtdMatServService';
  import powerupsActionsMixins from '@/mixins/powerupsActionsMixins';
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';

  export default {
    components: {
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
      GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue'),
      DialogCreationLog: () => import('@/components/general/DialogCreationLog'),
      DialogDelete: () => import('@/components/general/DialogDelete'),
      GeneralDialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes')
    },
    mixins: [powerupsActionsMixins, dateFormatterMixins],

    props: {
      items: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        required: true
      }
    },

    emits: ['switchProcessamentosExpirados', 'rechargeTable'],

    data: () => ({
      powerupService: TesteQtdMatServService,
      powerupEntityName: 'Qtd Material x Serviços',
      search: '',
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Título',
          value: 'titulo'
        },
        {
          text: 'Executado',
          value: 'executed'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-4'
        }
      ],
      loadingLogsTecnicos: false,
      dialogDelete: false,
      dialogDeleteData: { id: undefined, titulo: undefined }
    }),

    methods: {
      openDialogDetalhes(item) {
        this.dialogDetalhesData = [
          {
            parametro: 'Tipo da Base:',
            valor: item.tipo_base
          },
          {
            parametro: 'Obras:',
            valor: item.obras
          }
        ];

        this.dialogDetalhes = true;
      }
    }
  };
</script>

<style>
  .swithInterna label {
    font-size: 13px !important;
    margin-left: 0px !important;
  }
</style>
